import { Configuration, Environment } from './environment.type';

export const environment: Environment = {
  production: false,
  configuration: Configuration.Development,
  fetchPolicy: 'no-cache'
};
